<template>
  <div id="account-activation">
    <nav-bar-top icons-are-hidden is-primary />
    <div class="container has-nav-top-margin">
      <section
        v-if="isFetching"
        class="section has-text-centered"
      >
        <loading-spinner />
      </section>
      <section v-if="!isFetching && !isConfirmationScreen && !isTokenInvalidScreen" class="section">
        <h4 class="title is-4">
          Enter your new password
        </h4>
        <form
          @submit.prevent="validateBeforeSubmit()"
        >
          <div class="field">
            <label class="label">Password</label>
            <div class="control">
              <input
                v-model="newPassword"
                v-validate="'required'"
                class="input"
                name="password"
                type="password"
              >
              <p class="help is-danger">
                {{ errors.first('password') }}
              </p>
            </div>
          </div>
          <div class="control has-text-centered">
            <button
              id="reset-password-button"
              type="submit"
              class="button is-rounded is-primary has-text-weight-bold is-fullwidth"
              :class="isLoading ? 'is-loading' : ''"
            >
              Reset Password
            </button>
          </div>
        </form>
      </section>
      <section v-if="!isFetching && isTokenInvalidScreen" class="section">
        <h4 class="title is-4">
          Uh Oh!
        </h4>
        <p>
          Looks like this password reset token is invalid or has expired,
          please create a new one by going to the Log In screen and clicking
          'Forgot Password?'
        </p>
      </section>
      <section
        v-if="!isFetching && isConfirmationScreen"
        class="section"
      >
        <h4 v-if="!isError" class="title is-4">
          Success! Your password has been reset.
        </h4>
        <h4 v-else class="title is-4">
          Uh oh! Looks like there was an error resetting your password.
        </h4>
      </section>
      <section
        v-if="!isFetching && !isLoading && isConfirmationScreen"
        class="section no-pad-top"
      >
        <p v-if="!isError">
          Log In by clicking the button in the site header.
        </p>
      </section>
    </div>
  </div>
</template>

<script>
import NavBarTop from '@/components/Navigation/NavBarTop';
import LoadingSpinner from '@/components/Utilities/LoadingSpinner';

export default {
  name: 'AccountActivation',
  components: {
    LoadingSpinner,
    NavBarTop
  },
  data () {
    return {
      isFetching: true,
      isLoading: false,
      passwordResetToken: '',
      isConfirmationScreen: false,
      isTokenInvalidScreen: false,
      isError: false,
      newPassword: ''
    };
  },
  created () {
    this.passwordResetToken = this.$route.params.id;
    this.$store.commit('LOG_OUT');
    this.$store.dispatch('validatePasswordResetToken', { uuid: this.passwordResetToken })
      .then(response => {
        this.isFetching = false;
        if (response.data.status === 'fail') {
          this.isError = true;
          this.isTokenInvalidScreen = true;
        }
      })
      .catch(error => {
        console.log('Error validating reset token', error);
        this.isFetching = false;
        this.isError = true;
        this.isTokenInvalidScreen = true;
      });
  },
  methods: {
    handleSubmitNewPassword () {
      this.isLoading = true;
      this.$store.dispatch('updateUserPassword', {
        password: this.newPassword,
        uuid: this.passwordResetToken
      })
        .then(response => {
          this.isLoading = false;
          this.isConfirmationScreen = true;
          this.isError = false;
        })
        .catch(error => {
          console.log(error);
          this.isLoading = false;
          this.isConfirmationScreen = true;
          this.isError = true;
        });
    },
    validateBeforeSubmit () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.handleSubmitNewPassword();
          return;
        }
        console.log('Correct them errors!');
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
